<style lang="scss">
@import "../styles/payment-v2/payment-menu-content-summary.scss";
</style>

<template>
  <div>
    <div class="new-payment-ui-summary">
      <DocumentSpinner :is-visible="loading" />
      <div class="card-title" v-if="!hasErrorOnCart">
        {{ this.$t("$onboarding.content_paragraph.payment.summary.heading") }}
      </div>
      <div v-for="cartItem in shoppingCart" :key="cartItem.description" class="card-items">
        <v-layout v-if="!cartItem.isIncludedOnAccountingPlan && !cartItem.couponCode && !upgradeCorpSecSubscription">
          <v-flex>
            <div class="card-item" v-html="putBreakOnCorpSecService(cartItem.description)"></div>
            <div class="card-item-info">
              {{ cartItem.quantity > 1 ? " x" + cartItem.quantity : "" }}
              {{ cartItem.serviceDates != "" ? cartItem.serviceDates : "" }}
              <div
                class="item-info-spacer"
                v-if="
                  !accountingCodes.includes(cartItem.code) &&
                    !dormantCodes.includes(cartItem.code) &&
                    !accountingSoftwareCodes.includes(cartItem.code)
                "
              ></div>
            </div>
          </v-flex>
          <v-flex shrink>
            <div class="card-item-price">
              {{ formatPrice(cartItem.amount) }}
            </div>
          </v-flex>
        </v-layout>
        <v-layout v-else-if="!cartItem.isIncludedOnAccountingPlan && upgradeCorpSecSubscription">
          <v-flex v-if="cartItem.isNewSubscription">
            <div class="card-item-corp-sec">Corporate Secretary Upgrade (pro-rated)</div>
            <div class="card-item-corp-sec-info">{{ cartItem.description }}</div>
            <div class="item-info-spacer"></div>
          </v-flex>
          <v-flex class="credit-corp-sec" v-if="!cartItem.isNewSubscription">
            <div class="subs-period">Subscription Period: {{ cartItem.serviceDate }}</div>
            <div class="subs-description">{{ cartItem.description }}</div>
            <div class="credit-info">Remainder of current Corp Sec subscription, pro-rated</div>
            <div class="item-info-spacer" />
          </v-flex>
          <v-flex shrink align-self-center>
            <div :class="`${cartItem.isNewSubscription ? 'card-item-price' : 'credit-item-price'} `">
              {{ formatPrice(cartItem.amount, !cartItem.isNewSubscription) }}
            </div>
          </v-flex>
        </v-layout>
        <div v-if="cartItem.subDescription">
          <div class="card-item" v-html="putBreakOnCorpSecService(cartItem.subDescription)"></div>
        </div>
        <div v-if="accountingCodes.includes(cartItem.code)" class="accounting-inclusion">
          <ul>
            <li v-for="item in accountingPackageInclusion" :key="item">{{ item }}</li>
            <li v-for="subscription in accountingPlanInclusions" :key="subscription">{{ subscription }}</li>
          </ul>
        </div>
        <div v-if="dormantCodes.includes(cartItem.code)" class="accounting-inclusion">
          <ul>
            <li v-for="item in dormantPackageInclusion" :key="item">{{ item }}</li>
          </ul>
        </div>
        <div
          v-if="accountingSoftwareCodes.includes(cartItem.code) && !cartItem.isIncludedOnAccountingPlan"
          class="accounting-inclusion"
        >
          <ul>
            <li v-for="item in accountingSoftwareInclusions" :key="item">{{ item }}</li>
          </ul>
        </div>
      </div>
      <v-divider />
      <v-layout class="card-total" v-if="!hasErrorOnCart">
        <v-flex>
          <div class="subtotal-label">{{ this.$t("$onboarding.content_paragraph.payment.summary.subtotal") }}</div>
        </v-flex>
        <v-flex shrink>
          <div class="subtotal">{{ currency.symbol }}{{ Number(shoppingCartSubTotal).toLocaleString() }}</div>
        </v-flex>
      </v-layout>
      <v-layout class="card-total" v-if="!hasErrorOnCart && shoppingCartDiscount !== 0">
        <v-flex>
          <div class="total-discount">{{ this.$t("$onboarding.card.links.discount") }}</div>
        </v-flex>
        <v-flex shrink>
          <div class="discount">{{ currency.symbol }}{{ Number(shoppingCartDiscount).toLocaleString() }}</div>
        </v-flex>
      </v-layout>
      <v-layout v-for="dicountItem in fixedDiscounts" :key="dicountItem.description" class="card-total">
        <v-flex>
          <div class="total-discount">{{ $t("$onboarding.card.links.discount") }}</div>
        </v-flex>
        <v-flex shrink>
          <div class="discount">{{ formatPrice(dicountItem.amount, true) }}</div>
        </v-flex>
      </v-layout>
      <v-layout class="card-total" v-if="!hasErrorOnCart">
        <v-flex>
          <div class="total-label">{{ this.$t("$onboarding.content_paragraph.payment.summary.grand_total") }}</div>
        </v-flex>
        <v-flex shrink>
          <div class="total">{{ currency.symbol }}{{ Number(shoppingCartTotal).toLocaleString() }}</div>
        </v-flex>
      </v-layout>
      <v-layout class="card-total" v-if="hasErrorOnCart">
        <v-flex>
          <div class="total-label">Error in fetching cart details. Please contact application support.</div>
        </v-flex>
      </v-layout>
    </div>

    <div class="promo-code" v-if="promoCodeEnabled">
      <div class="toggle-link">
        <a href="#" @click="togglePromoCode()"
          >{{ this.$t("$onboarding.card.links.promo_code") }}
          <v-icon color="primary" v-if="promoCodeToggle">keyboard_arrow_up</v-icon>
          <v-icon color="primary" v-else>keyboard_arrow_down</v-icon>
        </a>
      </div>
      <v-layout class="promo-code-form" v-if="promoCodeToggle" align-center>
        <v-flex class="form-fields">
          <v-text-field
            :readonly="isCouponApplied"
            v-model="couponCode"
            :label="this.$t('$onboarding.fields.placeholders.promo_code')"
            outline
            hide-details
          ></v-text-field>
        </v-flex>
        <v-flex>
          <v-btn
            @click="onApplyPromoCode"
            v-if="!isButtonLoading && !isCouponApplied"
            color="primary"
            class="apply-button"
            small
            >{{ this.$t("$onboarding.card.buttons.apply") }}
          </v-btn>
          <v-btn
            v-if="!isButtonLoading && isCouponApplied"
            @click="onRemovePromoCode"
            :disabled="disableCoupon"
            small
            color="primary"
            class="apply-button"
            >{{ this.$t("$onboarding.card.buttons.remove") }}
          </v-btn>
        </v-flex>
      </v-layout>
      <span class="error-message-hint">{{ nameOnCardInputErrorMessage }}</span>
    </div>
  </div>
</template>

<script>
import { get, includes, find, isEmpty } from "lodash";
import moment from "moment";
// Components
import DocumentSpinner from "../../../../file-management/components/DownloadSpinner.vue";
// Proxies
import ApplyCouponCodeProxy from "@/proxies/back-end/coupon/lock";
import RemoveCouponCodeProxy from "@/proxies/back-end/coupon/unlock";
// Utilities
import ShoppingCartManager from "@/utilities/shopping-cart-manager";
import { getAppFeatureProp } from "@/utilities/app-feature-util";

import { renderSnackbarMessage } from "@/utilities/snackbar-util";

// Mixins
import { ConfigMixin } from "@/mixins/config-mixin";
import { PaymentLocaleMixin } from "@/mixins/payment-locale-mixin";
import { Constants } from "customer-sdk/constants";

const SHOPPING_CART_EVENTS = Constants.SHOPPING_CART_EVENTS;
const { SLEEK_DOMAINS } = Constants.SLEEK_DOMAINS;
//#region private methods
let applyPlatformSettings = component => {
  component.currency = component.platformConfig.currency;
  const onboarding = getAppFeatureProp(component.platformConfig.cmsAppFeatures, "onboarding");
  const accounting_step = getAppFeatureProp(onboarding.props, "accounting_step");
  component.accountingWithSoftware = get(accounting_step, "value.offerAccountingSoftware", false);
  const ADMIN_CONSTANTS = getAppFeatureProp(component.platformConfig.cmsGeneralFeatureList, "admin_constants");
  const XERO_STANDALONE_SETTINGS = getAppFeatureProp(ADMIN_CONSTANTS.props, "XERO_STANDALONE_SETTINGS");
  const ACTIVE_XERO_STANDALONE_CODE = get(XERO_STANDALONE_SETTINGS, "value.activeCode", "AC-110-RE-12");
  component.ACTIVE_XERO_STANDALONE_CODE = ACTIVE_XERO_STANDALONE_CODE;
};

let handleApplyCoupon = async component => {
  try {
    component.isButtonLoading = true;
    if (!component.couponCode) {
      component.nameOnCardInputErrorMessage = "Coupon code is required";
      return;
    }

    let companyId =
      component.requestPaymentItems && component.requestPaymentItems.length > 0
        ? localStorage.getItem("paymentRequestCompanyId")
        : localStorage.getItem("companyId");

    let proxy = new ApplyCouponCodeProxy();
    let payload = {
      code: component.couponCode.trim(),
      company_id: companyId,
      items: component.shoppingCart
    };
    let couponData = await proxy.execute(component.defaultPaymentData, payload);
    component.nameOnCardInputErrorMessage = null;
    if (component.requestPaymentItems && component.requestPaymentItems.length > 0) {
      component.shoppingCart.push({
        description: couponData.title,
        amount: couponData.amount,
        type: "couponCode"
      });
      component.paymentRequestTotalAmount += couponData.amount;
      component.isCouponApplied = true;
    }

    await fetchShoppingCartDetails(component);
    publishCouponApplied();
    renderSnackbarMessage("Promo code applied!");
  } catch (error) {
    component.nameOnCardInputErrorMessage = error.message;
  } finally {
    component.isButtonLoading = false;
  }
};

let handleRemoveCoupon = async component => {
  try {
    component.isButtonLoading = true;
    let companyId = get(component, "defaultPaymentData.id");
    let proxy = new RemoveCouponCodeProxy();
    let payload = {
      company_id: companyId
    };
    let couponData = await proxy.removeCouponCode(component.defaultPaymentData, payload);
    component.nameOnCardInputErrorMessage = null;
    if (component.requestPaymentItems && component.requestPaymentItems.length > 0) {
      component.shoppingCart = component.shoppingCart.filter(item => {
        return item.description !== couponData.title;
      });
      component.paymentRequestTotalAmount = component.paymentRequestTotalAmount - couponData.amount;
      component.isCouponApplied = false;
    }

    await fetchShoppingCartDetails(component);
    publishCouponApplied();
    renderSnackbarMessage("Promo code removed!");
  } catch (error) {
    component.nameOnCardInputErrorMessage = error.message;
  } finally {
    component.isButtonLoading = false;
  }
};

let publishCouponApplied = () => {
  ShoppingCartManager.publishChange({
    type: SHOPPING_CART_EVENTS.ON_SHOPPING_CART_ITEMS_CHANGED
  });
};

let handleShoppingCartTopics = component => {
  ShoppingCartManager.addListener(msg => {
    if (msg.type === SHOPPING_CART_EVENTS.ON_COMPANY_CHANGED) {
      fetchShoppingCartDetails(component);
    }
  });
};

let getServiceDates = item => {
  let serviceName = "";
  if (item.subscription_date_from && item.subscription_date_to) {
    let formattedDateFrom = moment(item.subscription_date_from).format("DD-MM-YYYY");
    let formattedDateTo = moment(item.subscription_date_to).format("DD-MM-YYYY");
    serviceName = `From: ${formattedDateFrom}, To: ${formattedDateTo}`;
  } else if (item.subscription_date_from) {
    let formattedDateFrom = moment(item.subscription_date_from).format("DD-MM-YYYY");
    serviceName = `From: ${formattedDateFrom}`;
  } else if (item.subscription_date_to) {
    let formattedDateTo = moment(item.subscription_date_to).format("DD-MM-YYYY");
    serviceName = `To: ${formattedDateTo}`;
  } else if (item.start_date && item.end_date) {
    let formattedDateFrom = moment(item.start_date).format("D MMM YYYY");
    let formattedDateTo = moment(item.end_date).format("D MMM YYYY");
    serviceName = `${formattedDateFrom} to ${formattedDateTo}`;
  }
  return serviceName;
};

let updateDecimalAmount = value => {
  if (value && value.toString().indexOf(".") !== -1) {
    if (value.toString().split(".")[1].length === 1 || value.toString().split(".")[1].length > 2) {
      return Number(value).toFixed(2);
    }
  }
  return value;
};

// eslint-disable-next-line
let fetchShoppingCartDetails = async component => {
  const sleekSiteOnboarding = getAppFeatureProp(
    component.platformConfig.cmsGeneralFeatureList,
    "sleek_site_onboarding"
  );
  let isDiscountEnabled = get(sleekSiteOnboarding, "value.is_discount_enabled", true);

  component.loading = true;
  if (component.requestPaymentItems && component.requestPaymentItems.length > 0) {
    component.isPaymentRequest = true;
    if (component.shoppingCart.length === 0) {
      component.requestPaymentItems.map(item => {
        let serviceDates = getServiceDates(item);
        let itemAmount = item.service_unit_price * item.quantity;
        let exactAmount = updateDecimalAmount(itemAmount);
        component.shoppingCart.push({
          description: item.service_name,
          amount: exactAmount,
          quantity: item.quantity,
          serviceDates: serviceDates,
          code: item.service_code
        });
        component.paymentRequestTotalAmount += item.service_unit_price * item.quantity;
      });
    }

    component.shoppingCartSubTotal = updateDecimalAmount(component.paymentRequestTotalAmount);
    component.shoppingCartTotal = updateDecimalAmount(component.paymentRequestTotalAmount);

    component.recomputeDiscounts(component.shoppingCart, [
      "appFeatures.billing_settings.credit_balances",
      "appFeatures.billing_settings.payment_request_discounts"
    ]);
  } else if (component.upgradeCorpSecSubscription) {
    const corpSecSubscriptionDetails =
      component.$store.getters["amendCompanyShareStructureStoreModule/corpSecSubscriptionDetails"];

    const { new_item, current_item, payment_details } = corpSecSubscriptionDetails;

    component.shoppingCart = [
      {
        description: new_item.name,
        amount: payment_details.new_item_amount,
        code: new_item.xero_code,
        isIncludedOnAccountingPlan: false,
        isNewSubscription: true
      },
      {
        description: payment_details.refund_item.name,
        amount: payment_details.refund_amount,
        code: payment_details.refund_item.xero_code,
        serviceDate: getServiceDates(current_item),
        isIncludedOnAccountingPlan: false
      }
    ];
    component.shoppingCartSubTotal = payment_details.total_amount_due;
    component.shoppingCartTotal = payment_details.total_amount_due;
    component.recomputeDiscounts(component.shoppingCart, ["appFeatures.billing_settings.credit_balances"]);
  } else if (component.addShareholderId) {
    //test
    let cart = new ShoppingCartManager();
    let response = await cart.fetchUpgradeCorpsecSubscriptionDetails(component.addShareholderId);

    if (response) {
      component.shoppingCart = response.shoppingCart;
      component.shoppingCartSubTotal = response.shoppingCartTotal;
      component.isCouponApplied = response.isCouponApplied;
      component.couponCode = get(find(response.shoppingCart, { code: "coupon" }), "couponCode", "");
    }

    component.recomputeDiscounts(component.shoppingCart, ["appFeatures.billing_settings.credit_balances"]);
  } else {
    if (!isEmpty(component.unpaidBillsDetails)) {
      let uBillTotalAmount = 0;
      component.unpaidBillsDetails.map(uBill => {
        uBillTotalAmount += uBill.amount;
        component.shoppingCart.push({
          description: uBill.description,
          subDescription: uBill.service_description,
          amount: uBill.amount,
          quantity: 1,
          code: uBill.xero_code
        });
      });
      component.shoppingCartSubTotal = uBillTotalAmount;
      component.shoppingCartTotal = uBillTotalAmount;
      component.recomputeDiscounts(component.shoppingCart, ["appFeatures.billing_settings.credit_balances"]);
    } else {
      console.log("FETCHING FROM CART");
      let cart = new ShoppingCartManager();
      let response = await cart.fetchShoppingCartDetails(
        component.subscriptionIds,
        component.oneOffCodes,
        null,
        component.companyIdFromBillingProfile
      );
      if (response && response.shoppingCartTotal !== undefined) {
        let responseShoppingCart = response.shoppingCart;
        if (!isDiscountEnabled) {
          responseShoppingCart = response.shoppingCart.filter(item => {
            return item.code !== "MI-10-OT-01" || item.code !== "MI-09-OT-01";
          });
        }

        if (component.accountingWithSoftware) {
          // Update description of Accounting Software Package
          let accountingSoftwareItem = responseShoppingCart.find(
            item => item.code === component.ACTIVE_XERO_STANDALONE_CODE
          );
          if (accountingSoftwareItem) {
            accountingSoftwareItem.description = "Accounting - Software";
          }
        }

        component.shoppingCart = responseShoppingCart; // response.shoppingCart;
        component.shoppingCartSubTotal = response.shoppingCartSubTotal;
        component.shoppingCartDiscount = response.shoppingCartDiscount;
        component.shoppingCartTotal = response.shoppingCartTotal;
        component.isCouponApplied = response.isCouponApplied;
        component.couponCode = get(find(response.shoppingCart, { code: "coupon" }), "couponCode", "");
      } else {
        component.hasErrorOnCart = true;
      }

      component.recomputeDiscounts(response.shoppingCart, [
        "appFeatures.billing_settings.credit_balances",
        "appFeatures.onboarding.fixed_discount"
      ]);

      if (isDiscountEnabled) {
        component.recomputeDiscounts(response.shoppingCart, ["appFeatures.onboarding.bundle_promotion"]);
      }
    }
  }

  component.loading = false;
};
//#endregion

export default {
  components: {
    DocumentSpinner
  },
  data() {
    return {
      couponCode: "",
      isButtonLoading: false,
      shoppingCart: [],
      shoppingCartTotal: 0,
      shoppingCartSubTotal: 0,
      shoppingCartDiscount: 0,
      isCouponApplied: false,
      nameOnCardInputErrorMessage: null,
      currency: {},
      loading: false,
      paymentRequestTotalAmount: 0,
      isHostSleek: true,
      promoCodeToggle: false,
      hasErrorOnCart: false,
      isPaymentRequest: false,
      fixedDiscounts: [],
      accountingWithSoftware: false,
      ACTIVE_XERO_STANDALONE_CODE: ""
    };
  },
  mixins: [ConfigMixin, PaymentLocaleMixin],
  computed: {
    accountingPackages() {
      const subscriptions = getAppFeatureProp(this.platformConfig.cmsGeneralFeatureList, "subscriptions");
      const full_accounting_packages = getAppFeatureProp(subscriptions.props, "full_accounting_packages");

      return full_accounting_packages.value || [];
    },
    dormantPackages() {
      const subscriptions = getAppFeatureProp(this.platformConfig.cmsAppFeatures, "subscriptions");
      const dormant_packages = getAppFeatureProp(subscriptions.props, "dormant_packages");

      return dormant_packages.value || [];
    },
    accountingSoftwarePackages() {
      const subscriptions = getAppFeatureProp(this.platformConfig.cmsAppFeatures, "subscriptions");
      const accounting_software_package = getAppFeatureProp(subscriptions.props, "accounting_software_package");

      return accounting_software_package.value || [];
    },
    accountingPackageInclusion() {
      let accountingPackagesInclusionList = [];
      const subscriptions = getAppFeatureProp(this.platformConfig.cmsAppFeatures, "subscriptions");
      const new_accounting_package_inclusions = getAppFeatureProp(
        subscriptions.props,
        "new_accounting_package_inclusions"
      );

      accountingPackagesInclusionList = new_accounting_package_inclusions && new_accounting_package_inclusions.value;

      if (this.accountingWithSoftware) {
        let updatedAccountingInclusions = getAppFeatureProp(subscriptions.props, "updated_accounting_inclusions");
        accountingPackagesInclusionList = updatedAccountingInclusions && updatedAccountingInclusions.value;
      }

      return accountingPackagesInclusionList;
    },
    dormantPackageInclusion() {
      const subscriptions = getAppFeatureProp(this.platformConfig.cmsAppFeatures, "subscriptions");
      const dormant_package_inclusions = getAppFeatureProp(subscriptions.props, "dormant_package_inclusions");

      return dormant_package_inclusions.value || [];
    },
    accountingSoftwareInclusions() {
      const subscriptions = getAppFeatureProp(this.platformConfig.cmsAppFeatures, "subscriptions");
      const accounting_software_inclusions = getAppFeatureProp(subscriptions.props, "accounting_software_inclusions");

      return accounting_software_inclusions.value || [];
    },
    accountingCodes() {
      return this.accountingPackages.map(acct => acct.xeroCode);
    },
    dormantCodes() {
      return this.dormantPackages.map(dormant => dormant.xeroCode);
    },
    accountingSoftwareCodes() {
      return this.accountingSoftwarePackages.map(accountingSoftware => accountingSoftware.xeroCode);
    },
    accountingPlanInclusions() {
      let planInclusions = [];
      let shoppingCart = this.shoppingCart;
      if (shoppingCart) {
        if (this.accountingWithSoftware) {
          // Remove multi currency
          planInclusions = shoppingCart
            .filter(item => item.isIncludedOnAccountingPlan && item.code !== "AC-19-OT-01")
            .map(item => item.description);
        } else {
          planInclusions = shoppingCart.filter(item => item.isIncludedOnAccountingPlan).map(item => item.description);
        }
      }
      return planInclusions;
    },
    totalDiscount() {
      let total = 0;
      this.shoppingCart.map(item => {
        if (item.couponCode) total += item.amount;
      });
      return total;
    },
    couponName() {
      let name = "";
      this.shoppingCart.map(item => {
        if (item.couponCode) name = item.description;
      });
      return name;
    }
  },
  methods: {
    formatPrice(amount, isNegative = false) {
      let component = this;
      if (amount == 0) {
        return this.$t("$onboarding.content_paragraph.payment.summary.packages.general.free");
      } else {
        if (isNegative) amount = -Math.abs(amount);

        let formattedPrice = component.currency.symbol + Number(amount).toLocaleString();

        return this.FORMAT_LOCALE_PRICE(formattedPrice);
      }
    },
    onApplyPromoCode: async function() {
      const component = this;
      await handleApplyCoupon(component);
    },
    onRemovePromoCode: async function() {
      const component = this;
      await handleRemoveCoupon(component);
    },
    putBreakOnCorpSecService: function(serviceDisplay) {
      return serviceDisplay.replace("Corporate Secretary (", "Corporate Secretary<br/>(");
    },
    togglePromoCode: function() {
      this.promoCodeToggle = !this.promoCodeToggle;
    },

    recomputeDiscounts: function(shoppingCart, code_paths) {
      const component = this;
      let discount_codes = [];

      code_paths.map(code_path => {
        let code_path_obj = {};
        const onboarding = getAppFeatureProp(component.platformConfig.cmsAppFeatures, "onboarding");
        if (code_path === "appFeatures.onboarding.fixed_discount") {
          const fixed_discount = getAppFeatureProp(onboarding.props, "fixed_discount");
          code_path_obj = {
            enabled: fixed_discount.enabled,
            xero_codes: fixed_discount.value.xero_codes
          };
        } else if (code_path === "appFeatures.onboarding.bundle_promotion") {
          const bundle_promotion = getAppFeatureProp(onboarding.props, "bundle_promotion");
          code_path_obj = {
            enabled: bundle_promotion.enabled,
            xero_codes: bundle_promotion.value.xero_codes
          };
        } else if (code_path === "appFeatures.billing_settings.credit_balances") {
          const billing_settings = getAppFeatureProp(component.platformConfig.cmsAppFeatures, "billing_settings");
          const credit_balances = getAppFeatureProp(billing_settings.props, "credit_balances");
          code_path_obj = {
            enabled: credit_balances.enabled,
            xero_codes: credit_balances.value.xero_codes
          };
        } else if (code_path === "appFeatures.billing_settings.payment_request_discounts") {
          const billing_settings = getAppFeatureProp(component.platformConfig.cmsAppFeatures, "billing_settings");
          const payment_request_discounts = getAppFeatureProp(billing_settings.props, "payment_request_discounts");
          code_path_obj = {
            enabled: payment_request_discounts.enabled,
            xero_codes: payment_request_discounts.value.xero_codes
          };
        } else {
          code_path_obj = get(component.platformConfig, `${code_path}`);
        }
        if (code_path_obj.hasOwnProperty("enabled") && code_path_obj.enabled === true) {
          discount_codes.push(...get(component.platformConfig, `${code_path}.xero_codes`));
          return;
        }
        if (!code_path_obj.hasOwnProperty("enabled")) {
          discount_codes.push(...get(component.platformConfig, `${code_path}.xero_codes`));
        }
      });
      component.shoppingCart = shoppingCart.filter(cart => !discount_codes.includes(cart.code));
      component.fixedDiscounts = shoppingCart.filter(cart => discount_codes.includes(cart.code));
      component.fixedDiscounts.map(item => {
        component.shoppingCartSubTotal -= -Math.abs(item.amount);
      });
    }
  },
  created() {
    let component = this;
    applyPlatformSettings(component);
    fetchShoppingCartDetails(component);
    handleShoppingCartTopics(component);
    component.isHostSleek = includes(SLEEK_DOMAINS, window.location.hostname);
  },

  props: {
    defaultPaymentData: Object,
    subscriptionIds: Array,
    oneOffCodes: Array,
    unpaidBillsDetails: Array,
    requestPaymentItems: Array,
    upgradeCorpSecSubscription: {
      type: Boolean,
      default: false
    },
    addShareholderId: String,
    promoCodeEnabled: {
      type: Boolean,
      default: true
    },
    companyIdFromBillingProfile: String
  }
};
</script>